import { arrType, datatypes, inputTypes } from "data/globalData";

export const itemMasterfilterColArry = [
    {
        name: "Brand",
        key: "brand",
        input_type: inputTypes.MULTIPLE_SELECT.key,
        constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
        data: {},
        data_type: datatypes.STRING.key,
        sort_no: 1,
        group: "",
        placeholder: "",
        default_value: "",
        select_options: {
            type: arrType,
            list: [],
        },
    },
    {
        name: "Division",
        key: "division",
        input_type: inputTypes.MULTIPLE_SELECT.key,
        constraints: { NOTNULL: true, DISPLAY: true, UNIQUE: false },
        data: {},
        data_type: datatypes.STRING.key,
        sort_no: 1,
        group: "",
        placeholder: "",
        default_value: "",
        select_options: {
            type: arrType,
            list: [],
        },
    },
    {
        name: "Season",
        key: "season",
        input_type: inputTypes.MULTIPLE_SELECT.key,
        constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
        data: {},
        data_type: datatypes.STRING.key,
        sort_no: 1,
        group: "",
        placeholder: "",
        default_value: "",
        select_options: {
            type: arrType,
            list: [],
        },
    },
    {
        name: "Department",
        key: "department",
        input_type: inputTypes.MULTIPLE_SELECT.key,
        constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
        data: {},
        data_type: datatypes.STRING.key,
        sort_no: 1,
        group: "",
        placeholder: "",
        default_value: "",
        select_options: {
            type: arrType,
            list: [],
        },
    },
    {
        name: "Extinct",
        key: "extinct",
        input_type: inputTypes.SELECT.key,
        constraints: { NOTNULL: false, DISPLAY: true, UNIQUE: false },
        data: {},
        data_type: datatypes.STRING.key,
        sort_no: 1,
        group: "",
        placeholder: "",
        default_value: "N",
        select_options: {
            type: arrType,
            list: [{ name: "Y", key: "Y" }, { name: "N", key: "N" }],
        },
    },
];
